import React, { useState, useEffect } from "react";
import lockimg from "../Assets/images/lock2_icon.png";
import awlogo from "../Assets/images/Group 16808.png";
import useCartStore from "../DataRepo/CartStore";
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import appointmentconfetti from '../Assets/animations/prakriticonfetti.json'
import { teleConsultationModel } from "../Axios/AxiosConfig";
import { IconButton, Button } from "@mui/material";
import OTPInput from "react-otp-input";
import axios from "axios"
import { Auth_URL } from '../Axios/config';
import { ArrowBack } from "@mui/icons-material";
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Lottie from "lottie-react";
import { setTokens, saveUserDetails } from "../Auth/AuthUtil";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { useNavigate } from "react-router-dom";

const CorpPackagelist = () => {

    const [companyEmail, setCompanyEmail] = useState("");

    const [open4, setOpen4] = useState(false);

    const [companyEmailError, setCompanyEmailError] = useState(null);

    const [isModalVisible, setIsModalVisible] = useState(false);

    const [error, setError] = useState('');

    const [timer, setTimer] = useState(0);

    const [isWaiting, setIsWaiting] = useState(false);

    const [otp, setOtp] = useState('');

    const { CouponErrorDetails, CompanyCodedetails, setCouponError, setCompanyCoupondetails, } = useCartStore()

    const [password, setPassword] = useState('')

    const generatePassword = () => {
        const length = 8;
        const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+[]{}|;:,.<>?";
        let password = "";
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * charset.length);
            password += charset[randomIndex];
        }
        return password;
    }

    const handleClose4 = () => {
        setOpen4(false);
    };

    const PackagePricing = {
        planName: "Premium Wellness Plan",

        duration: 3,

        price: 1000,

        orgprice: 2999,

        quantity: 3,

        teleconsultationlimit: 3,

        products_discount: 5,

        info: [
            'One session free Teleconsultation',
            'Personalized Dietary Plan',
            'Unlimited Chat feature',
            'Delicious Recipes Plan',
            'One Time Prakriti Assessment',
            'Tailored Lifestyle Practices',
            // 'Digital Pulse Diagnosis'
        ]
    }

    const price = PackagePricing?.price * PackagePricing?.duration;

    const discount = CompanyCodedetails?.discount || 0;

    const navigate = useNavigate()

    const maskFirstChars = (str, numChars) => {
        if (!str || str.length <= numChars) return '*'.repeat(str.length);
        return '*'.repeat(numChars) + str.slice(numChars);
    };

    const toggleModal = () => {
        setIsModalVisible(!isModalVisible);
    };

    useEffect(() => {
        let countdown;
        if (isWaiting && timer > 0) {
            countdown = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        } else if (timer === 0 && isWaiting) {
            setIsWaiting(false);
        }
        return () => clearInterval(countdown);
    }, [timer, isWaiting]);


    const handleResend = async () => {
        try {
            let res = await axios.post(`${Auth_URL}Resend-Confirmation-code`, {
                user: companyEmail,
            });

            if (res.status == 200) {
                setIsWaiting(true);
                setTimer(30);
                setOtp('')
                setError('')
            }
        }
        catch (err) {
            if (err.response.status === 500) {
                setError(err?.response?.data?.error)
                console.log(err?.response?.data)
            }
        }
    }

    const handleValidateCorporateUser = async () => {
        try {

            const newPassword = generatePassword()

            const res = await teleConsultationModel.post('/ValidateCorporateUser', {
                email: companyEmail,
                password: newPassword,
            })

            setPassword(newPassword)

            if (res.status === 200) {
                setCompanyEmailError(null)
                setIsModalVisible(true)
            }

        }

        catch (err) {
            if (err.response.status === 400 && err?.response?.data?.error?.includes('not confirmed')) {
                setCompanyEmailError(null)
                handleResend()
                setIsModalVisible(true)
            }
            else {
                setCompanyEmailError(err?.response?.data)
            }
        }
    }

    const handleVerifyCorpAccount = async () => {
        try {

            let res = await axios.post(`${Auth_URL}VerfiyCorpAccount`, {
                user: companyEmail,
                code: otp,
                password
            });

            if (res.status === 200) {

                setIsModalVisible(false)

                const { authDetails, companyDetails } = res.data

                const { accessToken, refreshToken, id } = authDetails;

                setTokens(accessToken, refreshToken);

                setCompanyCoupondetails(companyDetails);

                const firstname = '';
                const lastname = '';
                const email = companyEmail;
                const mobile = '';

                saveUserDetails(firstname, lastname, email, mobile, id);

                setOpen4(true)

            }
        }

        catch (err) {
            if (err?.response?.status === 500) {
                setError(err?.response?.data?.error)
                console.log(err?.response?.data)
            }
        }
    }
    
    return (
        <div className="min-h-screen bg-[#f8ecd7] flex flex-col items-center CorpPackagelist-card p-5 py-0">
            <nav className='flex flex-row w-full'>
                <IconButton onClick={() => navigate(-1)}>
                    <ArrowBack />
                </IconButton>
            </nav>

            <div className="w-full max-w-md text-center">

                <div className="mb-2 lock-img flex justify-center items-center">
                    <img src={awlogo} alt="AW Logo" />
                </div>

                <h2 className="text-2xl mt-3">
                    Wellness Made <br /> Affordable for You!
                </h2>

                <p className="mt-2 text-sm" style={{ color: "#625E55", fontFamily: "'Poppins', sans-serif", fontWeight: 400 }}>
                    Your employer truly prioritizes your health - enjoy an exclusive discount!
                </p>

            </div>

            <div className="mt-6 w-full max-w-md bg-[#DA6E0B1A] p-4 rounded-lg flex justify-between items-center border border-orange-500">
                <span className="text-2xl font-bold text-[#3B362A]" style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 600 }}>₹{price}</span>
                <span className="bg-[#75623F] text-white px-5 py-2 rounded text-sm" style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 400 }}>3 months plan</span>
            </div>

            <div className="mt-4 w-full max-w-md">

                <div className="flex items-center bg-white p-2 rounded-lg border border-gray-300">

                    <input
                        type="text"
                        placeholder="Enter company email"
                        value={companyEmail}
                        onChange={(e) => {
                            setCompanyEmail(e.target.value)
                            setCouponError(null)
                        }}
                        className="flex-1 outline-none text-gray-900 p-2 text-sm"
                    />

                    <button
                        className={`ml-2 px-4 py-2 rounded-lg text-white text-sm ${companyEmail ? "bg-[#8CEB8C]" : "bg-gray-300 cursor-not-allowed"}`}
                        onClick={() => {
                            handleValidateCorporateUser()
                        }}
                        disabled={!companyEmail}
                    >
                        Apply
                    </button>
                </div>

                <div>
                    {companyEmailError && (
                        <>
                            {companyEmailError?.error?.includes('Company not enrolled') ? (
                                <p className='couponError'>
                                    This company is not enrolled yet. Please ask your HR to contact business —{' '}
                                    <a href="https://ayurai.io/corporate" target="_blank" rel="noopener noreferrer" style={{ color: "blue", borderBottom: "1px solid blue" }}>
                                        click here
                                    </a>
                                    {' '}
                                    to get started
                                </p>
                            ) : (
                                <p className='couponError'>{companyEmailError?.error}</p>
                            )}
                        </>
                    )}
                </div>


            </div>

            <div className="mt-5 bg-[#DA6E0B1A] p-6 rounded-lg w-full text-center md:h-full" style={{ alignSelf: "flex-end" }}>
                <div className="lock-img flex justify-center items-center">
                    <img src={lockimg} alt="Lock Icon" />
                </div>
                <h3 className="text-orange-700 font-semibold text-lg mt-5 text-center">
                    Claim Your Employee Perks!
                </h3>
                <p className="text-sm mt-2 text-center" style={{ color: "#625E55", fontFamily: "'Poppins', sans-serif", fontWeight: 400 }}>
                    Unlock your reward by entering the company email
                </p>
            </div>


            {isModalVisible && (
                <div className="modal-overlay" onClick={toggleModal}>
                    <div className="bottom-sheet" onClick={(e) => e.stopPropagation()}>
                        <div className="handle"></div>
                        <div className="bottom-sheet-content">
                            <h2>Authentication Code</h2>
                            <p>Enter the 6 digit code send to your respective mail id ends with {maskFirstChars(companyEmail, 6)}</p>

                            <div className='login-otp-text-input'>

                                <div className='login-otp-text-input-div'>
                                    <OTPInput
                                        value={otp}
                                        onChange={setOtp}
                                        numInputs={6}
                                        inputStyle={{
                                            border: "1px solid transparent",
                                            borderRadius: "8px",
                                            width: "54px",
                                            height: "54px",
                                            fontSize: "16px",
                                            color: "#000",
                                            fontWeight: "500",
                                            outline: "1px solid silver",
                                            caretColor: "blue"
                                        }}

                                        renderSeparator={<span style={{ visibility: "hidden" }}>--</span>}
                                        renderInput={(props) => <input {...props} inputmode="numeric" />}
                                    />
                                </div>

                                <div className='login-otp-text-input-div'>
                                    <p style={
                                        isWaiting ? { visibility: 'visible' } : { visibility: "hidden" }
                                    }>{timer} s</p>

                                    {<p onClick={handleResend} style={
                                        !isWaiting ? { visibility: 'visible' } : { visibility: "hidden" }}>Resend Code</p>}

                                </div>

                                {error && <p style={{ color: 'red' }}>{error}</p>}

                                <div className='login-otp-text-input-div'>
                                    <Button
                                        style={{
                                            width: '100%',
                                            textTransform: 'none',
                                            borderRadius: '0',
                                            backgroundColor: '#DA6E0B',
                                            color: 'white',
                                            border: 'none',
                                            boxSizing: 'border-box',
                                            borderRadius: '5px',
                                            fontFamily: "'Poppins', sans-serif",
                                            fontWeight: 500,
                                            padding: '10px'
                                        }}
                                        onClick={handleVerifyCorpAccount}
                                    >
                                        Verify
                                    </Button>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            )}

            <Dialog
                open={open4}
                onClose={() => {
                    navigate('/packagecheckout')
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    style: { borderRadius: '10px', overflow: 'hidden' }
                }}
            >
                <DialogContent className='cpndialogbg2 bg-[#DA6E0B1A]' style={{ backgroundColor: "#DA6E0B1A !important" }}>

                    <div className="Lottie-background">
                        <Lottie animationData={appointmentconfetti}></Lottie>
                    </div>

                    <div className='flex justify-end'>
                        <IconButton onClick={() => {
                            navigate('/packagecheckout')
                        }}>
                            <CloseIcon></CloseIcon>
                        </IconButton>
                    </div>

                    <div className='flex flex-col items-center gap-3 justify-center'>

                        <div className='text-center'>

                            <p className="text-2xl text-[#DA6E0B]" style={{
                                color: "#DA6E0B",
                                fontFamily: "'Libre Baskerville', serif",
                                fontWeight: 700
                            }}>Congratulations!</p>

                        </div>

                        <img
                            alt="Company Logo"
                            style={{ width: "12rem" }}
                            src={CompanyCodedetails?.company_logo}
                        />

                        <div className="cpnsaved">
                            <p>offers</p>
                        </div>

                        <div className='ribbon'>
                            <p>{CompanyCodedetails?.couponType === 'percentage' ? `₹${discount}% off applied` : `₹${CompanyCodedetails?.cashRedeem} Flat Off`}</p>
                        </div>

                        <div className='cpnsaved'>
                            <p>You just have to pay ₹{CompanyCodedetails?.couponType === 'percentage' ?
                                (((price / 100) * discount).toFixed(2) - price) : (Math.abs(CompanyCodedetails?.cashRedeem - price))}</p>
                        </div>

                        <Button
                            style={{
                                textTransform: 'none',
                                borderRadius: '0',
                                backgroundColor: '#DA6E0B',
                                color: 'white',
                                display: "block",
                                fontSize: "12px",
                                border: 'none',
                                boxSizing: 'border-box',
                                borderRadius: '5px',
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 500,
                                padding: '10px 3rem'
                            }}
                            onClick={() => {
                                navigate('/packagecheckout')
                            }}
                        >
                            Claim Offer
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default CorpPackagelist;
